<template>
	<label class="mdc-text-field mdc-text-field--filled" :for="theId" :class="{'mdc-text-field--label-floating': hasValue, 'mdc-text-field--disabled': disabled == true, 'mdc-text-field--compact': compact,  'mdc-text-field--has-hint': hint}" ref="fieldRef">
		<span class="mdc-text-field__ripple" v-if="ripple"></span>
		<span class="mdc-text-field__affix mdc-text-field__affix--prefix" v-if="$slots.pre"><slot name="pre"></slot></span>
		<input class="mdc-text-field__input" :type="type" :name="name" :id="theId" :autocomplete="autocomplete" :placeholder="placeholder" :aria-label="label" :required="required" :aria-required="required" v-bind="$attrs" :value="modelValue" @input="input" :aria-disabled="disabled" :disabled="disabled" :tabindex="tabindex" :style="{textAlign: align}" :size="size" :maxlength="maxlength">
		<span class="mdc-text-field__affix mdc-text-field__affix--suffix" v-if="$slots.post"><slot name="post"></slot></span>
		<span class="mdc-text-field__affix mdc-text-field__affix--suffix" v-if="isLoading && !$slots.post">
			<i class="material-icons material-icons--spin">support</i>
		</span>

		<span class="mdc-floating-label" :class="{'mdc-floating-label--float-above': hasValue}" :id="`${theId}_label`" v-if="label">{{ label }}</span>
		<span class="mdc-line-ripple" v-if="ripple"></span>
		<div class="mdc-text-field-helper-line" v-if="hint">
			<div class="mdc-text-field-helper-text" :id="`hint_text_${theId}`" aria-hidden="false" v-html="hint"></div>
		</div>
	</label>
</template>

<script>
import { v4 } from 'uuid'
import { MDCTextField } from '@material/textfield'
import { isNotEmpty } from '@/lib/utils'
import { debounce } from 'lodash'

export default {
	name: 'FieldText',
	props: {
		autocomplete: String,
		align: {
			type: String,
			default: 'left',
		},
		compact: false,
		disabled: {
			type: Boolean,
			default: false,
		},
		id: {
			type: String,
			default: null
		},
		hint: String,
		label: String,
		name: String,
		type: String,
		placeholder: String,
		size: [Number,String],
		ripple: {
			type: Boolean,
			default: false,
		},
		minlength: {
			type: [Number, String],
			default: null,
		},
		maxlength: {
			type: [Number, String],
			default: null,
		},
		small: Boolean,
		required: false,
		modelValue: {
			type: [Number, String],
		},
		tabindex: Number|String,
		debounce: {
			type: Number,
			default: 0,
		},
		isLoading: Boolean,
	},
	data() {
		return {
			textfield: null,
			inputValue: this.modelValue,
			debouncedFn: null,
		}
	},
	computed: {
		theId() {
			if (this.id) return this.id
			return v4()
		},
		hasValue() {
			return isNotEmpty(this.modelValue)
		},
	},
	mounted() {
		this.$nextTick(() => {
			this.textfield = new MDCTextField(this.$el)
		})

		this.debouncedFn = debounce(emittedValue => {
			this.$emit('update:modelValue', emittedValue)
		}, this.debounce)
	},
	destroyed() {
		this.debouncedFn?.cancel()
	},
	methods: {
		input(evt) {
			const raw = evt.target.getAttribute('data-raw')
			if (raw) {
				this.inputValue = raw
				// this.$emit('update:modelValue', raw)
				// this.$emit('rawValue', raw)
			} else {
				this.inputValue = evt.target.value
				// this.$emit('update:modelValue', evt.target.value)
			}
		},
	},
	watch: {
		inputValue(newVal, oldVal) {
			if (newVal != oldVal) {
				this.debouncedFn(newVal)
			}
		},
	}
}
</script>

<style scoped lang="scss">
// @use "@material/floating-label/mdc-floating-label";
// @use "@material/line-ripple/mdc-line-ripple";
// @use "@material/notched-outline/mdc-notched-outline";
// @use "@material/textfield";
// @include textfield.core-styles;

.mdc-text-field {
// 	// --mdc-theme-primary: modules.color_('primary','dark');
// 	padding: 0 8px;
// 	width: 100%;

// 	&--filled {
// 		&:not(.mdc-text-field--disabled) {
// 			background-color: transparent;
// 		}

// 		.mdc-floating-label {
// 			left: 8px;

// 			&--float-above {
// 				left: 8px;
// 			}
// 		}
// 	}

// 	&__ripple {
// 		display: none;
// 	}

// 	// @include textfield.label-color(var(--color--dark-blue));

	&--compact {
		height: 44px;
		padding-left: 8px;
		padding-right: 8px;
		// border-radius: 100px;

		.mdc-text-field__input {
			font-size: 14px;
		}

		&.mdc-text-field--filled {
			&:before {
				height: 28px;
			}
		}

		.mdc-floating-label {
			font-size: 14px;
			left: 12px;
			// display: none;
		}
		&.mdc-text-field--label-floating {
		}

	}

	&--has-hint {

		overflow: visible;
		margin-bottom: 1.5rem;
		// @include modules.gutter('margin-bottom', 1.5);

		.mdc-text-field-helper-line {
			position: absolute;
			bottom: 0;
			left: 0;
			width: 100%;
			transform: translateY(90%);
		}

		.mdc-text-field-helper-text {
			color: var(--color--primary-text--light);
			opacity: 1;
		}
	}
// 	&:not(.mdc-text-field--disabled) {
// 		.mdc-floating-label {
// 			&--float-above {
// 				color: var(--color--dark-blue);
// 			}
// 		}
// 	}
}

:deep(.material-icons) {
	max-width: 24px;
}
</style>
